import axios from 'axios';
import { baseURL } from '../Constants';

const url = `${baseURL}/Replay`;

export const checkReplayAvailability = async (gameId: string): Promise<{ available: boolean; roundCount: number }> => {
    try {
        const response = await axios.get(`${url}/available/${gameId}`);
        return response.data;
    } catch {
        return { available: false, roundCount: 0 };
    }
};

export const fetchReplayRound = async (season: number, matchId: string, gameId: string, roundNumber: number): Promise<ArrayBuffer> => {
    const response = await axios.get(`${url}/round/${season}/${matchId}/${gameId}/${roundNumber}`, {
        responseType: 'arraybuffer',
    });
    return response.data;
};

export const getReplayGameIds = async (matchId: string): Promise<string[]> => {
    try {
        const response = await axios.get(`${url}/match/${matchId}`);
        return response.data;
    } catch {
        return [];
    }
};
